module.exports = __webpack_public_path__ + "img/rnd_square_bolt.prt.f6db6b13.jpg";